<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span><i>For Dalila</i></p>
<p class="ded"><i>And for Vita, whose spirit brought us together</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosson-0006.vue?2f02b859